export enum SaleTermsType {
    Default = 'default',
    Dialog = 'dialog',
    Checkbox = 'checkbox'
}